"use client";

import styles from "./checkout-card.module.css";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import React from "react";
import { formatMoney } from "src/lib/utils/formatter";

export interface CheckoutCardBillProps {
  subTotal: number;
  shipping: number;
  tax: number;
  discount: number;
  total: number;
  allowAddVoucher?: boolean;
}

const CheckoutCardBill = (props: CheckoutCardBillProps) => {
  const { subTotal, shipping, tax, discount, total, allowAddVoucher } = props;

  const renderVoucher = () => {
    if (!allowAddVoucher) return null;
    return (
      <>
        <FormControl size="small" fullWidth sx={{ margin: "16px 0" }}>
          <TextField label="Voucher" placeholder="Voucher" size="small" />
        </FormControl>
        <Button
          variant="outlined"
          size="small"
          fullWidth
          sx={{ textTransform: "none", fontWeight: "bold", margin: "0 0 16px" }}
        >
          Apply Voucher
        </Button>
      </>
    );
  };

  return (
    <Card className={styles.cardBox}>
      <Box className={styles.totalBox}>
        <Typography variant="body1" align="left" sx={{ color: "#4B566B" }}>
          Subtotal
        </Typography>
        <Typography variant="body1" align="right" sx={{ fontWeight: 600 }}>
          {formatMoney(subTotal)}
        </Typography>
      </Box>
      <Box className={styles.totalBox}>
        <Typography variant="body1" align="left" sx={{ color: "#4B566B" }}>
          Shipping
        </Typography>
        <Typography variant="body1" align="right" sx={{ fontWeight: 600 }}>
          {formatMoney(shipping)}
        </Typography>
      </Box>
      <Box className={styles.totalBox}>
        <Typography variant="body1" align="left" sx={{ color: "#4B566B" }}>
          Tax
        </Typography>
        <Typography variant="body1" align="right" sx={{ fontWeight: 600 }}>
          {formatMoney(tax)}
        </Typography>
      </Box>
      <Box className={styles.totalBox}>
        <Typography variant="body1" align="left" sx={{ color: "#4B566B" }}>
          Discount
        </Typography>
        <Typography variant="body1" align="right" sx={{ fontWeight: 600 }}>
          {formatMoney(discount)}
        </Typography>
      </Box>
      <Divider light sx={{ margin: "0 0 16px" }} />
      <Typography variant="body1" align="right" sx={{ fontWeight: 600, fontSize: "1.5rem" }}>
        {formatMoney(total)}
      </Typography>
      {renderVoucher()}
    </Card>
  );
};

CheckoutCardBill.displayName = "CheckoutCardBill";

export default CheckoutCardBill;
